import { signOutWithNotifications } from "../../firebase/notificationSession";
// components/auth/complete-profile.component.jsx
import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { auth } from "../../firebase/firebase.utils";
import {
  getOldestAllowedBirthDate,
  isAtLeast16,
  savePrivateDateOfBirth,
} from "../../firebase/auth-profile.utils";
import RetroButton from "../retro/button/retro-button.component";

import "./auth-gate.styles.scss";

const CompleteProfile = ({ onCompleted }) => {
  const [dateOfBirth, setDateOfBirth] = useState(null);
  const [busy, setBusy] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const saveBirthday = async () => {
    setErrorMessage("");

    if (!dateOfBirth) {
      setErrorMessage("Please select your date of birth.");
      return;
    }

    if (!isAtLeast16(dateOfBirth)) {
      setErrorMessage("You must be 16 or older to use Antlogy.");
      return;
    }

    const currentUser = auth.currentUser;
    if (!currentUser) {
      setErrorMessage("You have been signed out. Please log in again.");
      return;
    }

    try {
      setBusy(true);
      await savePrivateDateOfBirth(currentUser.uid, dateOfBirth);
      await onCompleted?.();
    } catch (error) {
      console.error("Birthday save failed:", error);
      setErrorMessage(
        error?.message === "profile/age-requirement"
          ? "You must be 16 or older to use Antlogy."
          : "We could not save your birthday. Please try again.",
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="authGate">
      <section className="authGate__card">
        <img
          className="authGate__logo"
          src="/antlogy_logo.png"
          alt="Antlogy"
        />
        <h1>Complete your profile</h1>
        <p>
          Before continuing, please add your date of birth. We use it to
          confirm you’re 16 or older and to support safety features.
        </p>

        <div className="authGate__birthday">
          <label htmlFor="profile-date-of-birth">Date of birth</label>
          <DatePicker
            id="profile-date-of-birth"
            selected={dateOfBirth}
            onChange={setDateOfBirth}
            maxDate={getOldestAllowedBirthDate()}
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            dateFormat="MMM d, yyyy"
            placeholderText="Select date"
            autoComplete="bday"
          />
        </div>

        <p className="authGate__privacy">
          Your exact birthday is kept in your private account data. It is not
          included in the user profiles loaded for workspaces, projects, chat,
          connections, or social features.
        </p>

        <RetroButton
          onClick={saveBirthday}
          disabled={busy}
          style={{ width: "100%" }}
        >
          {busy ? "Saving…" : "Continue"}
        </RetroButton>

        <button
          className="authGate__link"
          type="button"
          disabled={busy}
          onClick={() => signOutWithNotifications()}
        >
          Sign out
        </button>

        {errorMessage && (
          <p className="authGate__error" role="alert">
            {errorMessage}
          </p>
        )}
      </section>
    </main>
  );
};

export default CompleteProfile;
